import Grid from '@mui/material/Grid';
import React from 'react';
import PropTypes from 'prop-types';
function Sections({ children }) {
	return (
		<Grid container>
			{children.map((child) => (
				<Grid
					item
					key={child?.key}
					style={{ flex: `1 0 ${parseInt(100 / children.length, 10)}%` }}
				>
					{child}
				</Grid>
			))}
		</Grid>
	);
}

Sections.propTypes = {
	children: PropTypes.node,
};

export default Sections;
